import { Box, Card, CardContent, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomBarChart from "../../components/barChart";
import CustomRadarChart from "../../components/radarChart";
import { Info } from "@mui/icons-material";

function MissionEarnedChart({earnedBarData, avgEarned, avgPercentages}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return ( 
        <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4, marginRight: 2, marginBottom: 2 }}>
            <Card sx={{ flex: isMobile ? 1 : 2, borderRadius: 3, boxShadow: 2, backgroundColor: "background.main" }}>
                <CardContent>
                {/* <Typography variant="h9" color="grey" gutterBottom marginRight={2}>
                    Statistics
                </Typography> */}
                <Typography variant="subtitle" fontWeight="bold">
                    Mission Completed by Value Tags
                </Typography>
                <CustomBarChart
                    layout="horizontal"
                    data={earnedBarData}
                    filledLabel="Earned Mission"
                    highestLabel="Highest Earned Mission"
                    mode="stacked"
                />
                </CardContent>
            </Card>
            <Card sx={{ flex: isMobile ? 1 : 1.5, borderRadius: 3, boxShadow: 2, backgroundColor: "background.main" }}>
                <CardContent>
                {/* <Typography variant="h9" color="grey" gutterBottom marginRight={2}>
                    Statistics
                </Typography> */}
                <Box display="flex" alignItems="center">
                    <Typography variant="subtitle" fontWeight="bold">
                        Mission Points Earned by Value Tags
                    </Typography>
                    <Tooltip
                        title="Represents the proportion of mission points completed by employees for each value tag, shown as a percentage of the total mission points created for that tag."
                        arrow
                    >
                        <Info sx={{ ml: 1 }} />
                    </Tooltip>
                </Box>
                <CustomRadarChart
                    metricsWithName={avgEarned.metricsWithName}
                    metrics={avgEarned.metrics}
                    values={avgEarned.values}
                    percentages={avgPercentages.values}
                    valueFormatter={(v) => `${v}%`}
                />
                </CardContent>
            </Card>
            </Stack>
     );
}

export default MissionEarnedChart;